/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/order/status`,
    // @ts-ignore for sm-axios
    urlTemplate: '/order/status',
    method: 'POST',
    data: request.body,
  })
}

/**
 * whether the order link's email should create a password or sign in
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  body: {
    email: string
    partner: 'littlehotelier' | 'siteminder'
  }
}

export interface Response {
  state: 'register' | 'signin'
}

